/*
 * W MAGAZYNKU – pasek darmowej dostawy (snippets/wm-free-shipping-bar.liquid).
 * Nasłuchuje zapytań zmieniających koszyk (motyw używa jQuery/XHR, aplikacje – fetch),
 * po czym pobiera /cart.js i aktualizuje komunikat oraz wypełnienie paska.
 */
(function () {
  if (window.wmFreeShippingInit) return;
  window.wmFreeShippingInit = true;

  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function bars() {
    return document.querySelectorAll('[data-wm-fsb]');
  }

  function money(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.theme && theme.moneyFormat) {
      return Shopify.formatMoney(cents, theme.moneyFormat);
    }
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'PLN';
    return (cents / 100).toLocaleString('pl-PL', { style: 'currency', currency: currency });
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function fillTemplate(tpl, token, amount) {
    return escapeHtml(tpl).split(token).join('<strong>' + escapeHtml(amount) + '</strong>');
  }

  function render(total) {
    bars().forEach(function (bar) {
      var threshold = parseInt(bar.dataset.threshold, 10);
      if (!threshold) return;

      var state = total <= 0 ? 'empty' : total >= threshold ? 'done' : 'progress';
      var pct = Math.min(100, Math.floor((total * 100) / threshold));
      var html;
      if (state === 'empty') html = fillTemplate(bar.dataset.tplEmpty, '[threshold]', money(threshold));
      else if (state === 'progress') html = fillTemplate(bar.dataset.tplProgress, '[remaining]', money(threshold - total));
      else html = escapeHtml(bar.dataset.tplDone);

      var text = bar.querySelector('[data-wm-fsb-text]');
      if (text.innerHTML !== html) text.innerHTML = html;
      bar.dataset.state = state;

      var track = bar.querySelector('[data-wm-fsb-track]');
      track.setAttribute('aria-valuenow', state === 'empty' ? 0 : pct);
      track.firstElementChild.style.width = (state === 'empty' ? 0 : pct) + '%';
    });
  }

  var timer;
  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) { render(cart.total_price); })
        .catch(function () {});
    }, 200);
  }

  // fetch (aplikacje, nowsze skrypty)
  if (window.fetch) {
    var originalFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var request = originalFetch.apply(this, arguments);
      if (CART_MUTATION.test(url)) request.then(refresh, refresh);
      return request;
    };
  }

  // XHR (jQuery w nuranium.js)
  var originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_MUTATION.test(String(url))) this.addEventListener('loadend', refresh);
    return originalOpen.apply(this, arguments);
  };

  // powrót przyciskiem "wstecz" (bfcache) – koszyk mógł się zmienić na innej stronie
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refresh();
  });
})();
